export default {
  PAYMENT_API_URL: 'https://payment.circlechess.com',
  CHAT_API_URL: 'https://chat.circlechess.com',
  ANALYZE_GAME_API_URL:
    'https://crm-api.circlechess.com/game/start_analyzing_game',
  // CHESS_API_URL: 'https://stg.circlechess.com',
  CHESS_API_URL: 'https://api.circlechess.com',
  // CHESS_API_URL: 'http://localhost:8000',
  DEBUG_ENABLED: false,
  API_KEY: '3c311b2d-f168-47c2-9d2a-de5c2df8677a',
  GAME_SERVICE_URL: 'wss://gs.circlechess.com',
  SENTRY_DSN:
    'https://d51f03a321f54d59a4002ddb3e4d7310@alert.circlechess.com/3',
  X_API_KEY: '2d30f638-8922-4d8a-bb77-e25ad4af0aed',
  CAISSA_CHATBOT_API: 'https://65.1.214.145',
  TOURNAMENT_API_URL: 'https://event-api.circlechess.com/api',
  LMS_URL: 'https://lms.circlechess.com',
  //For Superset //crm prod
  SUPERSET_URL: 'https://superset.circlechess.com', //'http://13.200.189.214:8090',
  SUPERSET_USERNAME: 'ccstaff',
  SUPERSET_PASSWORD: 'ccstaff124',

  //Zoom
  ZOOM_CLIENT_ID: 'vQmoHYNFQY6RzjczanVLFA',
  ZOOM_IFRAME_BASE_URL: 'https://learn.circlechess.com/zoom',
  ZOOM_IFRAME_BASE_EXIT_URL: 'https://learn.circlechess.com/zoom',

  PAYPAL_SURCHARGE_RATE: 0.055, // 5.5% surcharge for PayPal/Apple Pay/Diner's Club
};
